import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Webcam from 'react-webcam';

const CameraCaptureComponent = ({sendCameraCloseDataFromChild, sendImageDataFromChild}) => {
    const { t } = useTranslation();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [imageSrc, setImageSrc] = useState(null);
	const webcamRef = React.useRef(null);
    const [file, setFile] = useState("");
	
	const closeModal = () => {
		sendCameraCloseDataFromChild(false);
	};

	const base64ToBlob = (base64Data, contentType = '', sliceSize = 512) => {
		const byteCharacters = atob(base64Data.split(',')[1]);
		const byteArrays = [];
		for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		  const slice = byteCharacters.slice(offset, offset + sliceSize);
		  const byteNumbers = Array.from(slice).map((char) => char.charCodeAt(0));
		  byteArrays.push(new Uint8Array(byteNumbers));
		}
		return new Blob(byteArrays, { type: contentType });
	};
	const capturePhoto = () => {
		const image = webcamRef.current.getScreenshot();
		setImageSrc(image);
		const blob = base64ToBlob(image, 'image/png');
		const file = new File([blob], 'screenshot.png', { type: 'image/png' });
		setFile(file);
	};

	const uploadImage = (e) => {
		sendImageDataFromChild(file)
	};

  return (
      <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
            <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-900 opacity-75" />
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
					{
						imageSrc 
						?
							<div>
								<img src={imageSrc} alt="Captured"/>
								<div className='p-2 flex justify-between'>
									<button onClick={(e) => setImageSrc(null)} type="button" className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('retake')}</button>
									<button onClick={(e) => uploadImage(e)} type="button" className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('upload photo')}</button>
								</div>
							</div>
						:
							<div>
								<Webcam
									audio={false}
									ref={webcamRef}
									screenshotFormat="image/jpeg"
									width="100%"
									videoConstraints={{
										facingMode: 'user', // Use the front camera
									}}
								/>
								<div className='p-2 flex justify-between'>
									<button onClick={capturePhoto} type="button" className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('capture photo')}</button>
									<button onClick={closeModal} type="button" className="capitalize text-white bg-blue-normal border-blue-normal text-center px-4 text-xs font-mediu py-2 border rounded-lg tracking-wide">{t('close camera')}</button>
								</div>
							</div>
					}
				</div>
			</div>
		</div>
  );
};

export default CameraCaptureComponent;
